import type { StudioPublishRequesterActions } from '../../../actions/studio/publish/publish-requester';
import { RESET_STUDIO_ACTION } from '../../consts';

export enum PUBLISH_REQUEST_STATUS {
    UNKNOWN = 'UNKNOWN',
    LOADING = 'LOADING',
    DONE = 'DONE',
    FAILED = 'FAILED'
}

export interface State {
    publishRequestStatus: PUBLISH_REQUEST_STATUS;
    publishRequestText: string;
}

const getDefaultState = (): State => ({
    publishRequestStatus: PUBLISH_REQUEST_STATUS.UNKNOWN,
    publishRequestText: ''
});

const studioPublishRequesterReducer = (state = getDefaultState(), action: StudioPublishRequesterActions | null): State => {
    switch (action?.type) {
        case 'SET_STUDIO_PUBLISH_REQUEST_PUBLISH_STARTED': {
            return {
                ...state,
                publishRequestStatus: PUBLISH_REQUEST_STATUS.LOADING
            };
        }

        case 'SET_STUDIO_PUBLISH_REQUEST_PUBLISH_DONE': {
            return {
                ...state,
                publishRequestStatus: PUBLISH_REQUEST_STATUS.DONE
            };
        }

        case 'SET_STUDIO_PUBLISH_REQUEST_PUBLISH_FAILED': {
            return {
                ...state,
                publishRequestStatus: PUBLISH_REQUEST_STATUS.FAILED
            };
        }

        case 'SET_STUDIO_PUBLISH_REQUEST_PUBLISH_TEXT': {
            return {
                ...state,
                publishRequestText: action.data.publishRequestText
            };
        }

        case RESET_STUDIO_ACTION: {
            return getDefaultState();
        }

        default: {
            return state;
        }
    }
};

export default studioPublishRequesterReducer;
